import React from "react";

export default function WishlistHeartIcon({
  size = 24,
  className = "header-svg"
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 99.999999 100"
    >
      <g transform="translate(-62.177076,-106.09792)">
        <path
          d="m 0,0 c -1.063,0 -2.117,-0.033 -3.17,-0.104 -28.361,-2.278 -52.137,-24.797 -56.465,-53.537 -8.03,-53.361 35.251,-102.256 72.98,-133.877 l 1.595,-1.343 c 10.269,-8.618 29.005,-24.35 40.974,-29.305 13.497,5.054 42.019,27.383 53.579,38.056 l 0.067,0.062 c 27.051,24.065 71.357,72.358 64.2,125.425 -3.645,26.97 -23.216,47.822 -49.877,53.133 -19.8,3.967 -46.755,-1.609 -62.767,-29.096 l -4.348,-7.47 -4.119,7.598 C 43.129,-12.913 20.502,0 0,0 m 55.686,-228.436 -1.49,0.522 c -13.516,4.751 -33.543,21.565 -45.502,31.607 l -1.594,1.338 c -39.627,33.22 -85.044,84.958 -76.34,142.771 4.983,33.158 32.47,59.146 65.358,61.789 22.428,1.49 47.372,-10.526 60.84,-28.773 16.088,22.243 41.801,32.617 68.823,27.226 30.79,-6.131 53.408,-30.221 57.604,-61.367 7.764,-57.504 -38.84,-108.597 -67.333,-133.953 -9.529,-8.799 -42.379,-35.783 -58.847,-40.709 z"
          transform="matrix(0.35277776,0,0,-0.35277776,92.082552,117.51806)"
        />
      </g>
    </svg>
  );
}

